/* generated by pull.js */
const manifest = {
  editorOnly: true,
  noTranslations: true,
  name: 'Customizable block colors',
  description: 'Edit block colors for each category in the editor.',
  credits: [
    {
      name: 'NitroCipher/ZenithRogue'
    },
    {
      name: 'TheColaber',
      link: 'https://scratch.mit.edu/users/TheColaber/'
    },
    {
      name: 'DNin01'
    }
  ],
  customCssVariables: [
    {
      name: 'commentText',
      value: {
        type: 'textColor',
        source: {
          type: 'settingValue',
          settingId: 'comment-color'
        }
      }
    },
    {
      name: 'commentTextTransparent',
      value: {
        type: 'textColor',
        black: 'rgba(0, 0, 0, 0.50)',
        white: 'rgba(255, 255, 255, 0.50)',
        source: {
          type: 'settingValue',
          settingId: 'comment-color'
        }
      }
    },
    {
      name: 'commentBorder',
      value: {
        type: 'multiply',
        source: {
          type: 'settingValue',
          settingId: 'comment-color'
        },
        r: 0.7,
        g: 0.7,
        b: 0.7
      }
    }
  ],
  dynamicDisable: true,
  userscripts: [
    {
      url: 'theme3.js'
    }
  ],
  userstyles: [
    {
      url: 'theme3.css'
    },
    {
      url: 'black_text.css',
      if: {
        settings: {
          text: 'black'
        }
      }
    },
    {
      url: 'color_on_white.css',
      if: {
        settings: {
          text: 'colorOnWhite'
        }
      }
    },
    {
      url: 'color_on_black.css',
      if: {
        settings: {
          text: 'colorOnBlack'
        }
      }
    }
  ],
  settings: [
    {
      dynamic: true,
      name: 'motion',
      id: 'motion-color',
      type: 'color',
      default: '#4C97FF',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'looks',
      id: 'looks-color',
      type: 'color',
      default: '#9966FF',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'sounds',
      id: 'sounds-color',
      type: 'color',
      default: '#CF63CF',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'events',
      id: 'events-color',
      type: 'color',
      default: '#FFBF00',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'control',
      id: 'control-color',
      type: 'color',
      default: '#FFAB19',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'sensing',
      id: 'sensing-color',
      type: 'color',
      default: '#5CB1D6',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'operators',
      id: 'operators-color',
      type: 'color',
      default: '#59C059',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'variables',
      id: 'data-color',
      type: 'color',
      default: '#FF8C1A',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'lists',
      id: 'data-lists-color',
      type: 'color',
      default: '#FF661A',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'custom',
      id: 'custom-color',
      type: 'color',
      default: '#FF6680',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'extensions',
      id: 'Pen-color',
      type: 'color',
      default: '#0FBD8C',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'Addon blocks',
      id: 'sa-color',
      type: 'color',
      default: '#29BEB8',
      allowTransparency: true,
      if: {
        addonEnabled: ['debugger']
      }
    },
    {
      dynamic: true,
      name: 'input color',
      id: 'input-color',
      type: 'color',
      default: '#FFFFFF',
      allowTransparency: true
    },
    {
      dynamic: true,
      name: 'comment color',
      id: 'comment-color',
      type: 'color',
      default: '#FEF49C',
      allowTransparency: true
    },
    {
      name: 'text',
      id: 'text',
      type: 'select',
      default: 'white',
      potentialValues: [
        { id: 'white', name: 'White' },
        { id: 'black', name: 'Black' },
        { id: 'colorOnWhite', name: 'Color on White' },
        { id: 'colorOnBlack', name: 'Color on Black' }
      ]
    }
  ],
  tags: ['theme'],
  enabledByDefault: true,
  presets: [
    {
      name: 'High contrast',
      id: 'contrast',
      description: "Scratch 3.0's high contrast block color palette",
      values: {
        'motion-color': '#80B5FF',
        'looks-color': '#CCB3FF',
        'sounds-color': '#E19DE1',
        'events-color': '#FFD966',
        'control-color': '#FFBE4C',
        'sensing-color': '#85C4E0',
        'operators-color': '#7ECE7E',
        'data-color': '#FFA54C',
        'data-lists-color': '#FF9966',
        'custom-color': '#FF99AA',
        'Pen-color': '#13ECAF',
        'sa-color': '#34E4D0',
        'comment-color': '#FEF49C',
        'input-color': '#FFFFFF',
        text: 'black'
      }
    },
    {
      name: 'Dark',
      id: 'new-dark',
      description: 'Dark versions of the default colors that look good in dark themes',
      values: {
        'motion-color': '#2461B7',
        'looks-color': '#633EAC',
        'sounds-color': '#863286',
        'events-color': '#AE8500',
        'control-color': '#B07200',
        'sensing-color': '#468CAF',
        'operators-color': '#438C43',
        'data-color': '#B46313',
        'data-lists-color': '#A84210',
        'custom-color': '#973545',
        'Pen-color': '#2A7468',
        'sa-color': '#2A797C',
        'comment-color': '#423F24',
        'input-color': '#FFFFFF',
        text: 'white'
      }
    },
    {
      name: 'Darker',
      id: 'dark',
      description: 'Even darker versions of the default colors',
      values: {
        'motion-color': '#004099',
        'looks-color': '#220066',
        'sounds-color': '#752475',
        'events-color': '#997300',
        'control-color': '#664100',
        'sensing-color': '#1f5f7a',
        'operators-color': '#235c23',
        'data-color': '#b35900',
        'data-lists-color': '#993300',
        'custom-color': '#99004d',
        'Pen-color': '#064734',
        'sa-color': '#166966',
        'comment-color': '#423f24',
        'input-color': '#202020',
        text: 'white'
      }
    },
    {
      name: 'Scratch 3.0 tweaked',
      id: 'tweaks',
      description:
        "Scratch 3.0's block colors with Events, Control, and Custom blocks that resemble Scratch 2.0's colors",
      values: {
        'motion-color': '#4C97FF',
        'looks-color': '#9966FF',
        'sounds-color': '#CF63CF',
        'events-color': '#DE9E2E',
        'control-color': '#FFBF00',
        'sensing-color': '#5CB1D6',
        'operators-color': '#59C059',
        'data-color': '#FF8C1A',
        'data-lists-color': '#FF661A',
        'custom-color': '#5f49d8',
        'Pen-color': '#0FBD8C',
        'sa-color': '#29BEB8',
        'comment-color': '#FEF49C',
        'input-color': '#FFFFFF',
        text: 'white'
      }
    },
    {
      name: 'Scratch 2.0 colors',
      id: 'original',
      description: 'The original block colors from Scratch 2.0',
      values: {
        'motion-color': '#4a6cd4',
        'looks-color': '#8a55d7',
        'sounds-color': '#bb42c3',
        'events-color': '#c88330',
        'control-color': '#e1a91a',
        'sensing-color': '#2ca5e2',
        'operators-color': '#5cb712',
        'data-color': '#ee7d16',
        'data-lists-color': '#cc5b22',
        'custom-color': '#632d99',
        'Pen-color': '#0e9a6c',
        'sa-color': '#29beb8',
        'comment-color': '#FFFFD2',
        'input-color': '#ffffff',
        text: 'white'
      }
    },
    {
      name: 'Black',
      id: 'black',
      description: 'Makes block backgrounds black and borders/text colored',
      values: {
        'motion-color': '#80B5FF',
        'looks-color': '#CCB3FF',
        'sounds-color': '#E19DE1',
        'events-color': '#FFD966',
        'control-color': '#FFBE4C',
        'sensing-color': '#85C4E0',
        'operators-color': '#7ECE7E',
        'data-color': '#FFA54C',
        'data-lists-color': '#FF9966',
        'custom-color': '#FF99AA',
        'Pen-color': '#13ECAF',
        'sa-color': '#34E4D0',
        'comment-color': '#FEF49C',
        'input-color': '#202020',
        text: 'colorOnBlack'
      }
    }
  ]
};
export default manifest;
